export default {
  data() {
    return {
      prevLevel: '',
      enterpriseType: ''
    };
  },
  mounted() {
    const path = this.$route.path;
    if (path.indexOf('productingEnterprise') > -1) {
      this.prevLevel = '生产数据监管';
      this.enterpriseType = '生产';
    } else if (path.indexOf('circulateEnterprise') > -1) {
      this.prevLevel = '流通数据监管';
      this.enterpriseType = '';
    }
  }
};
